import StackTraceError from './StackTraceError';

/**
 * Thrown on a 428 from login: credentials were fine, a code is still needed.
 */
export default class TwoFactorRequiredError extends StackTraceError {
  constructor(
    data = {},
    message = 'A verification code is required to finish logging in.',
    code = 428
  ) {
    super(message);
    this.data = data;
    this.code = code;
  }

  getChallenge = () => {
    const {
      challenge,
      channel,
      destination = null,
      expires_at: expiresAt = null,
      can_use_email: canUseEmail = false,
    } = this.data;
    return {
      challenge,
      channel,
      destination,
      expires_at: expiresAt,
      can_use_email: canUseEmail,
    };
  };

  getCode = () => this.code;
}
